import { render, staticRenderFns } from "./V2Auction.vue?vue&type=template&id=6a45126a&scoped=true&"
import script from "./V2Auction.vue?vue&type=script&lang=js&"
export * from "./V2Auction.vue?vue&type=script&lang=js&"
import style0 from "./V2Auction.vue?vue&type=style&index=0&id=6a45126a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45126a",
  null
  
)

export default component.exports